import { isTranscriptionFailureCode, type TranscriptionFailureCode } from '@kiao-voice/core'

// Re-exported so feature types can keep importing the failure-code type from
// this web module; the canonical definition lives in @kiao-voice/core, shared
// with the API so the two sides can't drift.
export type { TranscriptionFailureCode }

/**
 * Resolve a localized failure message for a failed transcription. Maps the
 * machine-readable `errorCode` to its `transcriptionError.<code>` i18n key,
 * falling back to the generic `transcriptionError.failed` for an unknown,
 * future, or missing code. Deliberately ignores the API's raw `errorMessage`
 * (English-only) so no untranslated string can leak onto a zh-TW page.
 */
export function transcriptionFailureMessage(
  t: (key: string) => string,
  errorCode: string | null | undefined
): string {
  const code = isTranscriptionFailureCode(errorCode) ? errorCode : 'failed'
  return t(`transcriptionError.${code}`)
}
